import axios from "axios";
import React, { Component } from "react";

import BrowserCheckAlert from "../browser/BrowserCheckAlert";
import RegistrationForm from "../components/registrationform";
import InvitationDetails from "./invitationdetails";
import { routes } from "utilities/routing/generatedRoutes";
import PanelSegmentType from "components/panels/PanelSegment/PanelSegment";
import { LoginWithGoogle } from "components/socialloginbuttons";

axios.defaults.timeout = 30000;

interface State {
  showRegister: boolean
  showHaveAccount: boolean
  usernameExists: boolean
}

interface Props {
  invitation: server.dto.Invitation
}

export default class LandingPage extends Component<Props, State> {
  state: State = {
    showHaveAccount: true,
    showRegister: false,
    usernameExists: false
  };

  handleSubmit = async (email: string, firstName: string, lastName: string, password: string, username: string, language: server.dto.Culture) => {
    const { invitation } = this.props;

    const formData: server.dto.AccountRegistrationInstruction = {
      email,
      firstName,
      lastName,
      password,
      username,
      locale: language.locale
    };

    return window.CoreApi.Register.SelfRegisterFromInvitation({
      account: formData,
      invitationType: this.props.invitation.type,
      secret: this.props.invitation.secret
    }).then(res => {
      switch (res.data.code) {
        case "success":
          document.location.href = invitation.paths.provideAbsolute;
          break;
        case "invitationAlreadyAccepted":
        case "invitationNotFound":
          document.location.href = invitation.paths.landingAbsolute;
          break;
        case "usernameExists":
          this.setState({ usernameExists: true });
          break;
        default:
          throw new Error(`RegisterAccountForAdvancing API is not happy: ${res.data.code}`);
      }
    });
  };

  createAccount = () => {
    this.setState({
      showHaveAccount: false,
      showRegister: true
    });
  };

  public render(): JSX.Element {
    const invitation = this.props.invitation;

    const signInUrl = `${routes.account_SignIn().absolute}?returnUrl=${encodeURIComponent(invitation.paths.landingAbsolute)}`;

    return (<div className="s1_main-panel medium">
      <BrowserCheckAlert browser={site.browser} />
      <InvitationDetails invitation={invitation} />

      {this.state.showHaveAccount && <div>

        <PanelSegmentType>
          <PanelSegmentType.Header size="h2">
            <PanelSegmentType.Title title={RESX.AdvancingInvitation.DoYouHaveASystemOneAccount} />
          </PanelSegmentType.Header>
        </PanelSegmentType>

        <div className="margin-bottom">
          <button
            className="button-new secondary fluid"
            onClick={this.createAccount}
          >
            {RESX.AdvancingInvitation.NoCreateAccount}
          </button>
        </div>

        <div>
          <a
            href={signInUrl}
            className="button-new primary fluid">
            {RESX.AdvancingInvitation.YesLogin}
          </a>
        </div>
      </div>}

      {this.state.showRegister && <RegistrationForm
        onSubmit={this.handleSubmit}
        signInUrl={signInUrl}
        suggestedUserDetails={this.props.invitation.suggestedUserDetails}
        suggestedLanguage={null}
      />}

      <div className="text-divider info-text-medium">{RESX.GeneralLabels.Or}</div>

      <div className="flex justify-center" id="social-logins" style={{ textAlign: "center" }}>
        <LoginWithGoogle url={invitation.paths.googleSignIn} />
      </div>
    </div>
    );
  }
}
